// extracted by mini-css-extract-plugin
export var actionButton = "_e7-0";
export var attachmentLine = "_e7-1";
export var fileInput = "_e7-2";
export var fileUploadWrapper = "_e7-4";
export var footer = "_e7-3";
export var modalContent = "_e7-5";
export var paperclip = "_e7-6";
export var quillEditor = "_e7-7";